import { Component, OnInit } from '@angular/core';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { map, Observable } from 'rxjs';
import { calculateAge, getKidType, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-predictor-layout-page',
  templateUrl: './predictor-layout-page.component.html',
  styleUrl: './predictor-layout-page.component.scss',
})
export class PredictorLayoutPageComponent implements OnInit {
  kidType$: Observable<KidTypeT>;
  isDefault: boolean;
  isKid: boolean;
  isClub1901: boolean;

  constructor(private memberQuery: MemberQuery, private populationQuery: PopulationQuery) {}

  ngOnInit() {
    this.kidType$ = this.memberQuery
      .selectMemberDetails()
      .pipe(map((m) => (m ? getKidType(calculateAge(new Date(m.DOB))) : 'Other')));
    this.isDefault = this.populationQuery.userInPopulation([Populations.Default]);
    this.isKid = this.populationQuery.userInPopulation([Populations.Kids]);
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
  }
}
